<template>
    <v-data-table
            :headers="headers"
            :items="companyBankAccounts"
            item-key="id"
            group-by="swift"
            group-asc
            group-key="swift"
            class="elevation-1 consent-table"
            hide-default-footer
            :items-per-page="9999999"
    >
        <template v-slot:group.header="{ group, headers, toggle, isOpen }">
            <td :colspan="headers.length - 1" class="pl-1 font-weight-bold">
                <v-btn :ref="group" :data-open="isOpen" icon small @click="toggle">
                    <v-icon v-if="isOpen">arrow_drop_down</v-icon>
                    <v-icon v-else>arrow_drop_up</v-icon>
                </v-btn>
                {{ swiftToBankName(group) }}
            </td>
            <td class="text-right">
                <v-icon @click="handleLogsClick(group)" title="Logs">mdi-folder-account-outline</v-icon>
            </td>
        </template>
        <template v-slot:item="{ item }">
            <tr
                :key="`cba_${item.id}`"
                class="consent-table-row"
                :class="{ activeTableRow: activeAccount && parseInt(item.id) === parseInt(activeAccount.id) }"
                @click="handleTableRowClick(item)"
            >
                <td>
                    <v-checkbox
                            hide-details
                            class="mt-0 mb-0"
                            v-model="item.pull_account"
                            @change="toggleCheckbox(item.id, item.pull_account)"
                    />
                </td>
                <td>{{ item.iban }}</td>
                <td>{{ getAccountName(item) }}</td>
                <td><span :style="{ 'background-color': item.is_fetched ? '#4CAF50' : '#FF0000' }" class="dot"></span></td>
                <td><span :style="{ 'background-color': getStatusColor(item.status) }" class="dot"></span></td>
                <td>{{ item.last_fetched ? tz(item.last_fetched) : "-" }}</td>
                <td>
                    {{ item.transactions_count ? `${item.related_transactions_count}/${item.transactions_count}` : "-" }}
                </td>
                <td class="text-right">
                    <v-icon @click="handleDownloadAccountDataClick(item)" title="Download account data">mdi-download</v-icon>
                </td>
            </tr>
        </template>
    </v-data-table>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import {bankMixin} from "@/mixins/bank-mixin";

export default {
    name: "consents-table",
    mixins: [bankMixin],
    data() {
        return {
            headers: [
                {
                    text: 'Pull',
                    align: 'start',
                    value: 'pull_account',
                    groupable: false,
                },
                {text: 'IBAN', value: 'iban', align: 'start'},
                {text: 'Owner name', value: 'owner_name', align: 'start'},
                {text: 'Is fetched', value: 'is_fetched', align: 'start'},
                {text: 'Status', value: 'status', align: 'start'},
                {text: 'Last fetched', value: 'last_fetched', align: 'start'},
                {text: 'Transactions count', value: 'transactions_count', align: 'start'},
                {text: 'Actions', value: 'actions', align: 'right'},
            ],
        }
    },
    computed: {
        ...mapState('ais', ['companyBankAccounts', 'activeAccount'])
    },
    methods: {
        ...mapActions('ais', ['togglePullAccount', 'downloadAccountData', 'getCompanyBankAccountData']),
        ...mapMutations('ais', ['setActiveLogSwift', 'setActiveAccount']),
        getAccountName(item) {
            if (item.owner_name && item.account_name) return `${item.owner_name} (${item.account_name})`;
            else if (item.owner_name) return `${item.owner_name}`;
            else if (item.account_name) return `${item.account_name}`;
            else return `-`;
        },
        async toggleCheckbox(id, value) {
            await this.togglePullAccount({id, value})
        },
        handleLogsClick(swift) {
            this.setActiveLogSwift(swift)
        },
        async handleDownloadAccountDataClick(item) {
            await this.$router.push({ name: "consent-account-view", params: { accountId: item.id, tabId: "1" } });
        },
        getStatusColor(status) {
            if (status === "finished") {
                return "#4CAF50";
            } else if (["failed", "cancelled"].includes(status)) {
                return "#FF0000";
            } else if (status === "pending") {
                return "#999999";
            } else if (status === "transactions_fetched") {
                return "#eec01f";
            } else {
                return "#999999";
            }
        },
        async handleTableRowClick(account) {
            if (this.$route.name !== "consent-account-view") {
                await this.$router.push({ name: "consent-account-view", params: { accountId: account.id, tabId: "0" } });
                return;
            }
            if (
                this.$route.name === "consent-account-view" &&
                parseInt(account.id) !== parseInt(this.$route.params.accountId)
            ) {
                await this.getCompanyBankAccountData(account.id);
                await this.$router.push({ name: "consent-account-view", params: { accountId: account.id, tabId: "0" } });
            }
        }
    }
}
</script>

<style scoped lang="scss">
.consent-table {
    width: 100%;
}
.activeTableRow {
    background-color: #707070;
    color: #fff;
}

.activeTableRow:hover {
    background-color: #8d8d8d !important;
    color: #fff !important;
}
.consent-table-row {
    cursor: pointer;
}
</style>